import { createContext } from 'react'

import { type ConnectedAccountContextType } from '@/providers/connectedAccount/types'

export const ConnectedAccountContext = createContext<ConnectedAccountContextType | undefined>(undefined)
